import React, { useRef } from "react";
import { toast } from "react-toastify";
import styles from "./ProfileShare.module.scss";

import { ReactComponent as ShareIcon } from "../../assets/images/share.svg";

export const getPublicUrl = (id) => {
  if (!id) return "";
  const host = window.location.host.match(/dedicated/)
    ? window.location.host.replace("dedicated", "assistants")
    : "assistants.getmagic.com";

  return `https://${host}/profile/${id}`;
};

const ProfileShare = ({ profile = {} }) => {
  const ref = useRef();
  const publicUrl = getPublicUrl(profile.public_url);

  return (
    <>
      {publicUrl ? (
        <div className={styles.ProfileShare} data-testid="ProfileShare">
          <ShareIcon
            data-testid="ShareIcon"
            role="button"
            onClick={() => shareProfileUrl(profile, publicUrl, ref)}
          />
          <textarea className={styles.TextArea} ref={ref} defaultValue={publicUrl} />
        </div>
      ) : null}
    </>
  );
};

const shareProfileUrl = (profile, url, ref) => {
  if (navigator.share) {
    navigator
      .share({
        title: `${profile.first_name}'s Assistant Profile`,
        url: url,
      })
      .then(() => {})
      .catch(console.error);
  } else {
    if (ref && ref.current) {
      ref.current.select();
      document.execCommand("copy");
      toast.success("Copied profile URL to clipboard!");
    }
  }
};

export default ProfileShare;
